/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_LoadingInputs */

const en_task_settings_loading = /** @type {(inputs: Task_Settings_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading activity settings…`)
};

const pt_br2_task_settings_loading = /** @type {(inputs: Task_Settings_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando configurações das atividades…`)
};

/**
* | output |
* | --- |
* | "Loading activity settings…" |
*
* @param {Task_Settings_LoadingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_loading = /** @type {((inputs?: Task_Settings_LoadingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_LoadingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_loading(inputs)
	return pt_br2_task_settings_loading(inputs)
});